.split {
  margin-right: auto;
}
